<template>
  <div id="metadata-check-results-table">
    <h4>{{ t('metadataCheckResultsTable.metadataCheck') }}</h4>

    <table-wrapper
      :fields="fields"
      :filter-display="false"
      :items="metadataCheckResults ?? []"
      :mode="TableMode.CLIENT_SIDE"
      :paginator="false"
      sort-field="field"
    >
    </table-wrapper>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import TableWrapper from '@/components/TableWrapper/TableWrapper.vue';
  import {
    DEFAULT_METADATA_VALUES_SEPARATOR,
    MetadataCheckResult,
  } from 'types';
  import { TableFieldsBuilder, TableMode } from '@/components/TableWrapper';

  const { t } = useI18n();

  defineProps<{
    metadataCheckResults: MetadataCheckResult[] | undefined;
  }>();

  const fields = computed(() =>
    new TableFieldsBuilder<MetadataCheckResult>({
      labelTranslationKey: 'metadataCheckResultsTable',
      sortable: true,
    })
      .addField('field', { width: '15%', valueGetter: metadataField })
      .addField('value', {
        width: '50%',
        valueGetter: metadataValue,
        truncation: {
          maxLength: 200,
        },
      })
      .addField('accepted', {
        width: '15%',
        valueTranslationKey: 'metadataCheckResultsTable.statuses',
      })
      .addField('errorMessage' as keyof MetadataCheckResult, { width: '20%' })
      .build(),
  );

  function metadataField(item: MetadataCheckResult): string {
    return t(`contentTypeFields.${item.field}`);
  }

  function metadataValue(item: MetadataCheckResult): string {
    const value = item.value;
    if (value.includes(DEFAULT_METADATA_VALUES_SEPARATOR)) {
      return value
        .split(';')
        .map((value) => value.split('|')[0])
        .join(', ');
    } else {
      return value.split('|')[0];
    }
  }
</script>

<style scoped lang="scss">
  h4 {
    margin-bottom: 1.5rem;
  }
</style>
